import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Button, Typography } from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";

import ModalRevisarRetencoes from './ModalRevisarRetencoes';
import ModalMaisDetalhes from './ModalMaisDetalhes';
import ModalEditar from './ModalEditar';
import RelacaoListItem from './RelacaoListItem';
import BuscaAvancada from './BuscaAvancada';
import Loading from '../../../Components/Loading';
import SemDados from '../../../Components/SemDados';
import TablePaginationCustom from '../../../Components/Table/TablePagination';
import ModalInfo from '../../../Components/ModalInfo';

import { setOpenBuscaAvancada, setParamsFilterRelacoesPrevidenciarias } from '../../../Store/Actions/Reducer/seguradoActions';
import { listarRelacoesPrevidenciarias } from '../../../Store/Actions/API/relacoesPrevidenciariasActions';
import { removeCharactersAndSpecialCharacter } from '../../../Utils/utils';

export default function RelacoesPrevidenciarias({ cpf }) {

    const dispatch = useDispatch();

    const paramsFiltroRelacoesPrevidenciarias = useSelector((state) => state.segurado.paramsFiltroRelacoesPrevidenciarias, shallowEqual);

    const [isLoading, setLoading] = useState(false);
    const [quantidadeBanco, setQuantidadeBanco] = useState(0);
    const [relacoesPrevidenciarias, setRelacoes] = useState([]);
    const [planoLimitado, setPlanoLimitado] = useState(false);

    const [relacaoSelecionada, setRelacaoSelecionada] = useState(null);
    const [openModalMaisDetalhes, setOpenModalMaisDetalhes] = useState(false);
    const [openModalRevisarRetencoes, setOpenModalRevisarRetencoes] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalInfo, setOpenModalInfo] = useState(false);

    useEffect(() => {
        lidarListagemRelacoes();
    }, [paramsFiltroRelacoesPrevidenciarias]); // eslint-disable-line

    const lidarListagemRelacoes = async () => {
        const filtros = {
            ...paramsFiltroRelacoesPrevidenciarias,
            cpf,
            cnpj: paramsFiltroRelacoesPrevidenciarias.cnpj ? removeCharactersAndSpecialCharacter(paramsFiltroRelacoesPrevidenciarias.cnpj) : "",
            origemVinculo: paramsFiltroRelacoesPrevidenciarias.origemVinculo ? paramsFiltroRelacoesPrevidenciarias.origemVinculo : "",
            tipoVinculo: paramsFiltroRelacoesPrevidenciarias.tipoVinculo ? paramsFiltroRelacoesPrevidenciarias.tipoVinculo : ""
        };

        setLoading(true);

        const response = await listarRelacoesPrevidenciarias(filtros);

        if (response !== null) {
            setQuantidadeBanco(response.quantidade ?? 0);
            setRelacoes(response.relacoes ?? []);
            setPlanoLimitado(response.bloquearConfirmacao || false);
        }

        setLoading(false);
    }

    const onChangePagination = (pag) => {
        dispatch(setParamsFilterRelacoesPrevidenciarias(pag));
    }

    const onClicaAbrirBusca = () => {
        dispatch(setOpenBuscaAvancada(true));
    }

    const onClicaRevisarRetencoes = (empresa) => {
        setRelacaoSelecionada(empresa);
        setOpenModalRevisarRetencoes(true);
    }

    const fechaModalRevisarRetencoes = (forcarReload = false) => {
        setRelacaoSelecionada(null);
        setOpenModalRevisarRetencoes(false);
        if(forcarReload){
            lidarListagemRelacoes();
        }
    }

    const onClicaMaisDetalhes = (empresa) => {
        setRelacaoSelecionada(empresa);
        setOpenModalMaisDetalhes(true);
    }

    const fechaModalMaisDetalhes = () => {
        setRelacaoSelecionada(null);
        setOpenModalMaisDetalhes(false);
    }

    const onClicaEditar = (empresa) => {
        setRelacaoSelecionada(empresa);
        setOpenModalEditar(true);
    }

    const fechaModalEditar = (relacaoEditada = null) => {
        setRelacaoSelecionada(null);
        if (relacaoEditada && relacaoEditada.id) {
            lidarListagemRelacoes();
        }
        setOpenModalEditar(false);
    }

    const forcarReload = () => {
        lidarListagemRelacoes();
    }

    return (
        <>
            {(relacaoSelecionada !== null && openModalMaisDetalhes) &&
                <ModalMaisDetalhes
                    open={openModalMaisDetalhes}
                    cpf={cpf}
                    relacaoSelecionada={relacaoSelecionada}
                    fechar={fechaModalMaisDetalhes}
                />}
            {(relacaoSelecionada !== null && openModalInfo) &&
                <ModalInfo
                    open={openModalRevisarRetencoes}
                    fechar={() => setOpenModalInfo(false)}
                    titulo={'Atenção'}
                    texto={`Este alerta é disparado quando o valor das retenções previdenciárias calculadas pelo sistema está divergente do valor informado na DIRF pela fonte pagadora.

                    Importante ressaltar que pequenas diferenças entre o valor calculado pelo sistema e o valor declarado pela fonte pagadora são aceitáveis, uma vez que na DIRF as retenções podem ser informadas pelo regime de caixa e não de competência.`}
                />}
            {(relacaoSelecionada !== null && openModalRevisarRetencoes) &&
                <ModalRevisarRetencoes
                    open={openModalRevisarRetencoes}
                    cpf={cpf}
                    relacaoSelecionada={relacaoSelecionada}
                    clicaAbrirInfo={() => setOpenModalInfo(true)}
                    fechar={fechaModalRevisarRetencoes}
                />}
            {(relacaoSelecionada !== null && openModalEditar) &&
                <ModalEditar
                    open={openModalEditar}
                    cpf={cpf}
                    relacaoSelecionada={relacaoSelecionada}
                    fechar={fechaModalEditar}
                />}
            <BuscaAvancada />
            {(relacoesPrevidenciarias && (relacoesPrevidenciarias.length > 0 || (
                paramsFiltroRelacoesPrevidenciarias.cnpj || paramsFiltroRelacoesPrevidenciarias.origemVinculo || paramsFiltroRelacoesPrevidenciarias.tipoVinculo
            ))) && (
                    <>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingLeft: 15, paddingRight: 15 }}>
                                <Button
                                    id="button_cancelar"
                                    variant="outlined"
                                    size="small"
                                    startIcon={<SearchIcon />}
                                    onClick={onClicaAbrirBusca}
                                >
                                    <Typography style={{ textTransform: "none" }}>
                                        Busca avançada
                                    </Typography>
                                </Button>
                            </div>

                            {relacoesPrevidenciarias.length > 0 &&
                                <div style={{ display: 'flex', flexDirection: 'column', height: `calc(100vh - 395px)`, overflowY: 'auto', paddingTop: 5, marginTop: 10, paddingBottom: 10, paddingLeft: 8, paddingRight: 8 }}>
                                    {relacoesPrevidenciarias.map((relacaoPrev, index) => (
                                        <RelacaoListItem
                                            cpf={cpf}
                                            key={index}
                                            onClicaRevisarRetencoes={onClicaRevisarRetencoes}
                                            onClicaMaisDetalhes={onClicaMaisDetalhes}
                                            onClicaEditar={onClicaEditar}
                                            forcarReload={forcarReload}
                                            planoLimitado={planoLimitado}
                                            relacao={relacaoPrev}
                                            index={index}
                                        />
                                    ))}
                                </div>
                            }
                            {relacoesPrevidenciarias.length > 0 && <div style={{ height: 50, paddingTop: 5 }}>
                                <TablePaginationCustom count={quantidadeBanco} onChangePagination={onChangePagination}
                                    pagination={{ ...paramsFiltroRelacoesPrevidenciarias }} />
                            </div>}

                            {relacoesPrevidenciarias.length === 0 && <SemDados text="Nenhum registro encontrado para o filtro aplicado." />}

                        </div>
                    </>
                )}
            {(!isLoading && (relacoesPrevidenciarias.length === 0) && !(
                paramsFiltroRelacoesPrevidenciarias.cnpj || paramsFiltroRelacoesPrevidenciarias.origemVinculo || paramsFiltroRelacoesPrevidenciarias.tipoVinculo
            )) && (
                    <SemDados text="Nenhum registro encontrado" />
                )}
            {isLoading ? <Loading text={"Carregando relações previdenciárias..."} /> : null}
        </>
    )
}